var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM58(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5433_44381",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5433_44381",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB0ElEQVRo3uWaP3KCQBSHSeMJ7GQmSautOUWSipobYENaOYXjdeisVAYPoL1dRsRuIb+XYWc0MfwbWPYRZ77GgZnfpyz7dt8aRgOf08owgQ0WwAcHEAGREWXf+dk1dK1pdPl5DGbD58BxP1cPa4RJQFoRumdzfJ+6x9eXocrgI7AEl6fASSAgaoSXiOPbNIHABSzBqM3gA+CBGKREgwJpRgw8MGg6/ASEMniLApIdmDQV3gLnn+FbFiDOwKqfPP0OPwPiXngFAoQAs7q/PIVP/gqvSIBIKktkj43IC69QQP4TVpUBey4Kr1hAjolJmVflrkz4DgTk22mQJ+CVDd+RAOHlzbAxA4H47oydlQcpAwFi+aswo9qGkcDlpgBEmI+q4TsWINxrgS1Dga0MbxbNuJoK0H0mCdh1wmsgQNgksGAssCABn7GATwIHxgJ7EogYC0RGmbJZYwHRCwHOj9CpF4OY/WuU/UTGvpTgXcwxLqc31+sBl/uChveSkv2ivhfbKow2tuZFW4uhxgJhYfdG883dcf+3168kHI0aHE7dLo2jQYvJ+adNvluJseI2a1h6wFZsdM8VNLrnjTe6e3HUoKXDHmvlhz1KHrfZg5OK4zZfTWg0bVr1pLgAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM58);
export default __webpack_public_path__ + "static/media/m58.11652fd138c5219320ab255d98590905.svg";
export { ForwardRef as ReactComponent };